import { KeyIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { useForm } from 'libs/form'
import { BackButton, Form, FormSection, Header } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { routes } from 'config/routes'
import { useChangePasswordMutation } from './mutations/useChangePasswordMutation'

const ChangePassword = () => {
	const { t } = useTranslation()
	const {
		handleSubmit,
		register,
		setError,
		formState: { errors }
	} = useForm()

	const { changePasswordMutation, changePasswordIsLoading } = useChangePasswordMutation(setError)

	const onSubmit = (data: any) => {
		changePasswordMutation(data)
	}

	return (
		<>
			<Header title={t('Change password')} actions={<BackButton to={routes.profileIndex} />} />
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Change password')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={changePasswordIsLoading}>
					<FormSection
						title={t('Password')}
						description={t('Update the password you use to sign in.')}
						icon={<KeyIcon />}>
						<InputGroup
							id="old_password"
							type="password"
							className="sm:col-span-2"
							label={t('Old password')}
							autoComplete="current-password"
							{...register('old_password')}
							error={(errors as any).old_password}
						/>
						<InputGroup
							id="password"
							type="password"
							label={t('New password')}
							autoComplete="new-password"
							{...register('password')}
							error={(errors as any).password}
						/>
						<InputGroup
							id="password2"
							type="password"
							label={t('Confirm new password')}
							placeholder={t('Repeat the password')}
							autoComplete="new-password"
							{...register('password2')}
							error={(errors as any).password2}
						/>
					</FormSection>
				</Form>
			</div>
		</>
	)
}

export default ChangePassword
